// the Uniswap Default token list lives here
export const DEFAULT_TOKEN_LIST_URL = 'https://gateway.pinata.cloud/ipfs/QmVn2QGjheb6V3KNomXhzTEbLz6VN3nEmXQbiaywzCqCas?_gl=1*10am7ds*rs_ga*OTEyODUwNmItODk5Yy00ODIxLTk4YTEtNDVkZWYxZjczMDYy*rs_ga_5RMPXG14TE*MTY4MjE1ODkyOS4xLjEuMTY4MjE1OTY1NS42MC4wLjA.'

export const DEFAULT_LIST_OF_LISTS: string[] = [
  DEFAULT_TOKEN_LIST_URL,
  'https://gateway.pinata.cloud/ipfs/QmVn2QGjheb6V3KNomXhzTEbLz6VN3nEmXQbiaywzCqCas?_gl=1*10am7ds*rs_ga*OTEyODUwNmItODk5Yy00ODIxLTk4YTEtNDVkZWYxZjczMDYy*rs_ga_5RMPXG14TE*MTY4MjE1ODkyOS4xLjEuMTY4MjE1OTY1NS42MC4wLjA.'
]
